import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { QueryClient, QueryClientProvider } from 'react-query';

import Banner from '@components/Banner';

import UserProfileForm from './Form';

const queryClient = new QueryClient();
const UserProfile = () => {
  const [showEnableProfileBanner, setShowEnableProfileBanner] = useState(false);

  return (
    <QueryClientProvider client={queryClient}>
      {showEnableProfileBanner && (
        <Banner
          contentText={
            'Your profile is disabled. Enable it to make changes and connect with other subscribers.'
          }
        />
      )}
      <Container id="UserProfileSettings">
        <UserProfileForm setShowEnableProfileBanner={setShowEnableProfileBanner} />
      </Container>
    </QueryClientProvider>
  );
};

export default UserProfile;
